import { Component, EventEmitter, Input, Output, OnInit, ViewChild, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { fadeInOut } from '../router.animations';
import { LayoutService } from '../layout.service';
import { NavigationService } from '../navigation.service';
import { BreakpointsService } from '../breakpoints.service';
import { ImageGalleryService } from '../image-gallery.service';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { appConfig } from '../app.config';
import * as imagesLoaded from 'imagesloaded';
import { map, forEach } from 'lodash';
import '../orientationchangeend.js';

@Component({
  selector: 'app-image-gallery-view',
  templateUrl: './image-gallery-view.component.html',
  styleUrls: ['./image-gallery-view.component.scss'],
  host: {
    '(window:resize)': 'onResize()',
    '(click)': 'onClick($event)',
    '[@fadeInOut]': ''
  },
  animations: [
    fadeInOut,
    trigger('hideShow', [
      state('hide', style({
        opacity: '0',
        zIndex: 13,
        visibility: 'hidden'
      })),
      state('show',   style({
        opacity: '1',
        zIndex: 15,
        visibility: 'visible'
      })),
      transition('hide => show', animate('800ms ease-in')),
      transition('show => hide', animate('800ms ease-out'))
    ])
  ]
})
export class ImageGalleryViewComponent implements OnInit {  
  @ViewChildren('imageRef') imageRef: QueryList<ElementRef>;
  @ViewChild('viewport') viewportRef: ElementRef;
  
  @Input() images: any[] = null;
  @Input() image: any[] = null;
  @Input() currentIndex: number = null;
  
  public imageSrcBase = appConfig.imageUrl;
  imagesWithState: any[] = null;
  resizeTimeout;
  showLoader: boolean = true;
  currentImageEl: any;
  orientationChangeEnd: any;
  orientationEventListener: any;
  breakpointSubscription: any;
  imageChangeSubscription: any;

  constructor(
    private NavigationService: NavigationService,
    private location: Location,
    private BreakpointsService: BreakpointsService,
    private LayoutService: LayoutService,
    private ImageGalleryService: ImageGalleryService,
    private router: Router
  ) {
  }

  ngOnInit() {
    setTimeout(() => {
      this.LayoutService.isLandscapeEnabled = true;
      this.NavigationService.isHidden = true;
    });

    // To prevent visible jump in page in mobile when
    // gallery inits
    setTimeout(() => {
      this.LayoutService.overflow = 'hidden';
    }, 500);

    if (this.image !== null) {
      this.images = [this.image];
      this.currentIndex = 0;
    }

    this.imagesWithState = map(this.images, (image: any) => {
      return {
        ...image,
        state: 'hide',
        inited: false
      };
    });

    this.orientationChangeEnd = window['gajus'].orientationchangeend({});
 
    // Attach event listener to the "orientationchangeend" event. 
    this.orientationEventListener = this.orientationChangeEnd.on('orientationchangeend', this.onResize.bind(this));

    //xoxo DRY 
    setTimeout(() => {
      if (this.imageRef.toArray().length > 0) {
        let imageRefIndex = 1;
        if (this.currentIndex === 0) {
          imageRefIndex = 0;
        } else if (this.currentIndex === this.imagesWithState.length - 1) {
          imageRefIndex = this.imageRef.toArray().length - 1;
        }
        this.currentImageEl = this.imageRef.toArray()[imageRefIndex].nativeElement;
        imagesLoaded(this.currentImageEl, () => {
          this.fitImageToViewport();
        });
      }
    });

    this.breakpointSubscription = this.BreakpointsService.deviceObs.subscribe((device) => {
      this.fitImageOnLoad();
    });

    this.imageChangeSubscription = this.ImageGalleryService.onChangeImage.skip(1).subscribe(index => {
      this.setImage(index);
    });
  }

  ngOnDestroy() {
    setTimeout(() => {
      this.LayoutService.isLandscapeEnabled = false;
      this.LayoutService.overflow = null;
    });
    this.orientationChangeEnd.off(this.orientationEventListener);
    
    if (typeof this.breakpointSubscription !== 'undefined') {
      this.breakpointSubscription.unsubscribe();
    }
    if (typeof this.imageChangeSubscription !== 'undefined') {
      this.imageChangeSubscription.unsubscribe();
    }
  }

  onResize() {
    this.resizeTimeout = setTimeout(() => {
      this.imagesWithState[this.currentIndex].state = 'hide';
      this.fitImageToViewport();
    }, 200);
  }

  isImageShow(index: number) {
    if (index === this.currentIndex ||
      index === this.mod(this.currentIndex + 1, this.imagesWithState.length) ||
      index === this.mod(this.currentIndex - 1, this.imagesWithState.length)) {
    }
    return index === this.currentIndex ||
      index === this.mod(this.currentIndex + 1, this.imagesWithState.length) ||
      index === this.mod(this.currentIndex - 1, this.imagesWithState.length);
  }

  fitImageToViewport() {
    let viewportEl = this.viewportRef.nativeElement;
    let currentImageItem = this.imagesWithState[this.currentIndex];
    let viewportWidth = viewportEl.clientWidth;
    let viewportHeight = viewportEl.clientHeight;

    if (!currentImageItem.inited) {
      let imageWidth = this.currentImageEl.naturalWidth;
      let imageHeight = this.currentImageEl.naturalHeight;
      currentImageItem.ratio = imageHeight / imageWidth;
      currentImageItem.inited = true;
    }

    let containerRatio = viewportHeight / viewportWidth;
    let isFitToHeight = currentImageItem.ratio > containerRatio;
    currentImageItem.isFitToHeight = isFitToHeight;

    setTimeout(() => {
      if (isFitToHeight) {
        currentImageItem.height = viewportHeight > this.currentImageEl.naturalHeight ? this.currentImageEl.naturalHeight : viewportHeight;
        currentImageItem.width = null;
      } else {
        currentImageItem.height = null;
        currentImageItem.width = viewportWidth > this.currentImageEl.naturalWidth ? this.currentImageEl.naturalWidth : viewportWidth;
      }
      this.showLoader = false;

      currentImageItem.state = 'show';
    });
  }

  setImageLocation(index: number) {
    let path = this.location.path().replace(/\/gallery\/[^\?]+(\?)|\/gallery\/[^\?]+$/, `/gallery/${(index + 1)}$1`);
    this.location.go(path);
  }

  setImage(index: number) {
    this.imagesWithState[this.currentIndex].state = 'hide';

    this.currentIndex = index;

    if (!this.imagesWithState[this.currentIndex].inited) {
      this.showLoader = true;
    }

    this.fitImageOnLoad();
  }

  selectImage(index: number) {
    this.setImageLocation(index);
    this.setImage(index);
  }

  fitImageOnLoad() {
    setTimeout(() => {
      let imageRefIndex = 1;
      if (this.currentIndex === 0) {
        imageRefIndex = 0;
      } else if (this.currentIndex === this.imagesWithState.length - 1) {
        imageRefIndex = this.imageRef.toArray().length - 1;
      }
      this.currentImageEl = this.imageRef.toArray()[imageRefIndex].nativeElement;

      imagesLoaded(this.currentImageEl, () => {
        this.fitImageToViewport();
      });
    });
  }

  closeOverlay() {
    this.ImageGalleryService.closeGallery();
  }

  onClick($event) {
    if (this.BreakpointsService.device !== 'desktop' ||
      ($event.target.tagName !== 'IMG' && this.imagesWithState && this.imagesWithState.length === 1)) {
      this.closeOverlay();
    }
  }

  //xoxo duped
  mod(n, m) {
    return ((n % m) + m) % m;
  }

  changeImage(direction) {
    let index = direction === 'next' ? this.currentIndex + 1 : this.currentIndex - 1;
    let currentIndex = this.mod(index, this.imagesWithState.length);

    this.selectImage(currentIndex);
  }
}



// WEBPACK FOOTER //
// ./src/app/image-gallery-view/image-gallery-view.component.ts